import { capitalizeVariables } from 'util/strings.util';
import { TaskRowType } from '../../tasks/tasks.model';

/** The enum value reads as one word, so only the revision type needs spelling out. */
export const getTaskTypeLabel = (type: TaskRowType): string => {
  if (type === TaskRowType.QuestionnaireRevision) return 'Questionnaire Revision';
  return capitalizeVariables(type) ?? '--';
};
